export default "__VITE_ASSET__jb3u$YTX__"